export const SET_USER = 'user/SET_USER';
export const SET_MESSAGE = 'user/SET_MESSAGE';
export const LOGOUT_USER = 'user/LOGOUT_USER';
export const SET_SUBSCRIPTION = 'user/SET_SUBSCRIPTION';
export const SET_LOADING = 'user/SET_LOADING';
export const LOGIN_USER = 'user/LOGIN_USER';
export const GET_LOGGED_STUDENT = 'user/GET_LOGGED_STUDENT';
export const REQUEST_PASSWORD = 'user/REQUEST_PASSWORD';
export const RESET_PASSWORD = 'user/RESET_PASSWORD';
export const GET_TRIAL_USER_PROGRESS = 'user/GET_TRIAL_USER_PROGRESS';
export const SET_CANT_STUDY = 'user/SET_CANT_STUDY';
export const SET_LAST_NOTIFICATIONS_REQUEST =
  'user/SET_LAST_NOTIFICATIONS_REQUEST';
export const SET_LAST_USER_NOTIFICATIONS_REQUEST =
  'user/SET_LAST_USER_NOTIFICATIONS_REQUEST';
export const UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ =
  'user/UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ';
export const SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ =
  'user/SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ';
export const SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ_MESSAGE =
  'user/SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ_MESSAGE';
export const SET_LOADING_UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ =
  'user/SET_LOADING_UPDATE_USER_SETTING_QUAL_FOR_DAILY_QUIZ';
export const SET_CHANGE_STUDY_SPEED_SETTINGS =
  'user/SET_CHANGE_STUDY_SPEED_SETTINGS';
export const VERIFY_IS_MAINTENANCE = 'user/VERIFY_IS_MAINTENANCE';
